'use strict';

var _ = require('lodash');
var ChartControlsBoardController = function ChartControlsBoardController($scope, constants, flightModeService) {
  $scope.buttonText = 'Maximum number of reference flights: ' + constants.MAX_AMOUNT_OF_REFERENCE_ENTITIES;
  $scope.isDAOnlyMode = flightModeService.isDAOnlyMode();
  $scope.$watchCollection('contextData.referenceEntities', function (newValue) {
    $scope.addFlightButtonDisabled = _.isArray(newValue) ? newValue.length > constants.MAX_AMOUNT_OF_REFERENCE_ENTITIES - 1 : false;
  });
  $scope.toggleSelection = function (item) {
    item.selected = !item.selected;
    $scope.contextData.legendFilter = _.reduce($scope.contextData.chartData.referenceButtons, function (result, button) {
      return !button.hidden && !button.selected ? _.concat(result, button.id) : result;
    }, []);
  };
};
ChartControlsBoardController.$inject = ['$scope', 'ProfileChartConstants', 'FlightModeService'];
module.exports = ChartControlsBoardController;